import { ApiResponse } from "../../types/types";

/** Matches scraper/utils/httpclient WriteErrorResponse → SendResponse error shape. */
export class ApiRequestError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
  }
}

export function getErrorMessage(error: unknown, fallback = "Request failed"): string {
  if (error instanceof ApiRequestError || error instanceof Error) {
    return error.message.trim() || fallback;
  }
  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }
  return fallback;
}

export async function parseApiResponse<T>(response: Response): Promise<T | undefined> {
  if (response.status === 204 || response.status === 304) {
    if (!response.ok) {
      throw new ApiRequestError(`HTTP error ${String(response.status)}`, response.status);
    }
    return undefined;
  }

  let payload: ApiResponse<T>;
  try {
    payload = (await response.json()) as ApiResponse<T>;
  } catch {
    throw new ApiRequestError(`HTTP error ${String(response.status)}`, response.status);
  }

  const code = payload.code || response.status;
  if (!response.ok || code >= 400) {
    const message = payload.message?.trim() || `HTTP error ${String(code)}`;
    throw new ApiRequestError(message, code);
  }

  return payload.body;
}
